angular.module('qbePortal').controller('ctpFormController', [
	'$rootScope',
	'$scope',
	'$state',
	'$stateParams',
	'userInputRepository',
	'dynamicRouter',
	'labelService',
	'Util',
	'$http',
	'storage',
	'gtmService',
	'MODULE_INFO',
	'vcRecaptchaService',
	function(
		$rootScope,
		$scope,
		$state,
		$stateParams,
		userInputRepository,
		dynamicRouter,
		labelService,
		util,
		$http,
		storage,
		gtmService,
		MODULE_INFO,
		vcRecaptchaService
	) {
		var $ctrl = this;

		/**
		 * routing initialisation, enabling/disabling (hiding/showing) available routes
		 * testing for allowed routes and redirecting when not allowed
		 */
		function markCompletedRouteCallback(stateName) {
			storage.setItem('completed-step', stateName);
		}

		function initialiseRouting() {
			dynamicRouter.initialise(
				$state.current.name,
				$state.$current.parent.name,
				null,
				markCompletedRouteCallback
			);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}
		/** End of routing logic */

		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.sections = {};
		$ctrl.moduleId = MODULE_INFO.id;
		$ctrl.recaptchaResponse = null;

		function getDefaultValues() {
			var defaultValues = {
				ctpForm: {
					promotionalCode: {
						value: $stateParams.promotionalCode
							? $stateParams.promotionalCode
							: ''
					},
					token: {
						widgetId: null,
						response: ''
					},
					incentiveDetails: {
						directDebit: true
					}
					
				}
			};
			return defaultValues;
		}

		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$('html, body').animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left
				});
			}
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function(name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn
			};
		};

		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on('error', function(event, error) {
			$state.go('error', error);
		});

		function getUserInput() {
			var formData = getFormInput();

			if ($ctrl.response && $ctrl.response !== '') {
				formData.ctpForm.token.widgetId = $ctrl.widgetId;
				formData.ctpForm.token.response = $ctrl.response;
			}

			userInputRepository.update(formData);
			var defaultValues = getDefaultValues();
			return userInputRepository.get(defaultValues);
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}
			return formData;
		}

		function openDialog() {
			$rootScope.$broadcast('loading-animation-start');

			getUserInput();

			$rootScope.$broadcast('open-confirmation-dialog');
		}

		$ctrl.submit = function(e, form) {
			$ctrl.showErrorSummary = false;

			gtmService.trackCTPEvent(
				'gaClick',
				$state.current,
				e.target.textContent
			);

			if (form.$invalid) {
				$scope.$broadcast('broadcast-field-errors');
				$ctrl.showErrorSummary = true;
				$scope.$broadcast('reset-field-errors');
				scrollViewTo($('#combinedValidationListing'));
				return;
			}

			if ($ctrl.visible == 'invisible') {
				vcRecaptchaService.execute($ctrl.widgetId);
			} else {
				if ($ctrl.response !== '') {
					openDialog();
				}
			}
		};

		/**
		 * Initialisation method of the payment page
		 */
		$ctrl.initPage = function() {
			storage.clear();

			$ctrl.visible = globals.recaptchaConfiguration.options[0].type;
			$ctrl.recaptchaKey = globals.recaptchaConfiguration.options[0].key;

			initialiseRouting();
			util.dispatchCustomEvent('register-labels');
			$ctrl.termsAndConditions = false;
			var formData = getUserInput();
			$ctrl.formData = formData;
			var defaultValues = getDefaultValues();	
			userInputRepository.update(defaultValues);
		};

		$ctrl.setResponse = function(response) {
			$ctrl.response = response;

			if ($ctrl.visible === 'invisible' && $ctrl.response !== '') {
				openDialog();
			}
		};

		$ctrl.setWidgetId = function(widgetId) {
			$ctrl.widgetId = widgetId;
		};

		$ctrl.cbExpiration = function() {
			vcRecaptchaService.reload($scope.widgetId);

			$ctrl.response = '';
		};

		$scope.$on('terms-and-conditions-changed', function(
			event,
			termsAndConditions
		) {
			$ctrl.termsAndConditions = termsAndConditions;
		});

		$scope.$on('reload-recaptcha', $ctrl.cbExpiration);
	}
]);
